import { z } from 'zod';

import { StrictAddress } from '../Address';
import { VerificationOfMortgagePurpose } from '../documents/VerificationOfMortgage';
import { BaseLoanEvent } from './BaseLoanEvent';

export const CreateVerificationOfMortgageEvent = BaseLoanEvent.extend({
  type: z.literal('createVerificationOfMortgage'),
  purpose: VerificationOfMortgagePurpose,
  otherPurpose: z.string().optional(),
  recipientName: z.string(),
  companyName: z.string(),
  recipientAddress: StrictAddress,
});
export type CreateVerificationOfMortgageEvent = z.infer<typeof CreateVerificationOfMortgageEvent>;
